import { LottieChat } from '@/components/chat-lottie'
import { Chat } from '@/features/chats'
import { usePreviewRailStore } from '@/features/editor/components/preview/preview-rail-store'

export function PreviewRailPanel() {
  const resetKey = usePreviewRailStore((s) => s.resetKey)
  const previewSessionId = usePreviewRailStore((s) => s.previewSessionId)
  const isRestarting = usePreviewRailStore((s) => s.isRestarting)

  // 如果没有预览会话，显示提示
  if (!previewSessionId) {
    return (
      <div className='bg-background flex h-full flex-col overflow-hidden rounded-xl border shadow-sm'>
        <div className='shrink-0 border-b px-4 py-3'>
          <div className='min-w-0 space-y-0.5'>
            <div className='text-base font-medium'>预览</div>
          </div>
        </div>
        <div className='flex flex-1 items-center justify-center'>
          <p className='text-muted-foreground text-sm'>点击预览按钮开始预览</p>
        </div>
      </div>
    )
  }

  return (
    <div className='bg-background flex h-full flex-col overflow-hidden rounded-xl border shadow-sm'>
      {/* Header：仅展示信息，不放任何操作 */}
      <div className='shrink-0 border-b px-4 py-3'>
        <div className='min-w-0 space-y-0.5'>
          <div className='text-base font-medium'>预览</div>
          <div className='text-muted-foreground truncate text-xs'>
            基于已保存版本 · 修改内容请先保存再预览
          </div>
        </div>
      </div>

      {/* Body：Chat 区域 */}
      <div className='min-h-0 flex-1'>
        <div className='h-full overflow-hidden'>
          {isRestarting ? (
            <div className='flex h-full items-center justify-center'>
              <LottieChat className='h-32 w-32' />
            </div>
          ) : (
            /* key 用来重载 / 清空 mock 对话（由全局控制） */
            <Chat key={resetKey} sessionId={previewSessionId} />
          )}
        </div>
      </div>
    </div>
  )
}
